import { Alignment, Position, AutoSize } from './types';

export const ALIGNMENTS: Alignment[] = ['top', 'bottom', 'start', 'end', 'center'];
export const POSITIONS: Position[] = ['above', 'below', 'before', 'after'];
export const AUTOSIZES: AutoSize[] = ['height', 'height-always', 'width', 'width-always', 'always', true, false];
